import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetBooksQuery } from "../../features/api/apiSlice";
import { getBooks } from "../../features/booksSlice";
import BookSkeleton from "../ui/loaders/BookItem";
import Error from "../ui/loaders/Error";
import NoContent from "../ui/loaders/NoContent";
import BookItem from "./BookItem";
import FilterBooks from "./FilterBooks";

const BookList = () => {
  const { data, isLoading, isError } = useGetBooksQuery();
  const { books, filter, query } = useSelector((state) => state.books);
  const dispatch = useDispatch();

  const filterBooks = () => {
    if (filter === "All") {
      return books;
    } else if (filter === "Featured") {
      return books.filter((book) => book?.featured === true);
    }
  };

  const filteredBooks = filterBooks();

  const searchBooks = () => {
    return filteredBooks.filter((book) =>
      book?.name.toLowerCase().includes(query.toLowerCase())
    );
  };

  const searchedBooks = searchBooks();

  let content = null;

  if (isLoading) {
    content = (
      <>
        <BookSkeleton />
        <BookSkeleton />
        <BookSkeleton />
        <BookSkeleton />
      </>
    );
  }
  if (!isLoading && !isError && data) {
    dispatch(getBooks(data));
  }
  if (!isLoading && isError) {
    content = <Error message="There was an error" />;
  }

  if (!isLoading && !isError && searchedBooks?.length === 0) {
    content = <NoContent message="No data found!" />;
  }

  if (!isLoading && !isError && searchedBooks?.length > 0) {
    content = searchedBooks.map((book) => (
      <BookItem key={book.id} book={book} />
    ));
  }
  return (
    <main className="py-12 px-6 2xl:px-6 container">
      <div className="order-2 xl:-order-1">
        <FilterBooks />
        <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
          {content}
        </div>
      </div>
    </main>
  );
};

export default BookList;
